import { createDocumentPagePdfEngine, isSupportedImageFile } from '../shared/documentPagePdfEngine';

const engine = createDocumentPagePdfEngine(85.6, 54);

export { isSupportedImageFile };
export const resolveOrientation = engine.resolveOrientation;
export const computeCardLayout = engine.computeCardLayout;
export const computeNidCopyPairRects = engine.computeCopyPairRects;
export const loadImageFromFile = engine.loadImageFromFile;
export const renderNidPreviewCanvas = engine.renderPreviewCanvas;
export const createNidPdf = engine.createPdf;
export const createNidPageImage = engine.createPageImage;
